import { render, staticRenderFns } from "./ArtistRow.vue?vue&type=template&id=b768a946&scoped=true&"
import script from "./ArtistRow.vue?vue&type=script&lang=js&"
export * from "./ArtistRow.vue?vue&type=script&lang=js&"
import style0 from "./ArtistRow.vue?vue&type=style&index=0&id=b768a946&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b768a946",
  null
  
)

export default component.exports